import React, { useState } from 'react';
import ModalElement from '../../../Common/ModalElement';
import InputElement from '../../../Common/InputElement';
import ButtonElement from '../../../Common/ButtonElement';
import { appApis, dropdownDefaultList } from '../../../constants';
import { useApiRequest } from '../../../hooks/useApiRequest';
import { validateInput } from '../../../utils';
import SearchableDropdown from '../../../Common/SearchDropdown';

// Static configuration 
const API_CONFIG = {
    'Inventory Types': appApis.addInventoryTypes,
    'Software Providers': appApis.addSoftwareProvider,
    'Device Models': appApis.addDeviceModal,
    'Supplier': appApis.createSupplier,
    'Warehouses': appApis.wareHouse,
    'SIM Providers': appApis.addSimProviders
};

const AddModal = ({ show, onHide, activeTab, onSuccess }) => {
    const [modalData, setModalData] = useState({
        name: '',
        nameErr: null,
        deviceType: ""
    });

    const { request, loading } = useApiRequest();

    // Handle modal input changes
    const handleModalChange = (e) => {
        const { name, value } = e.target;
        setModalData(prev => ({
            ...prev,
            [name]: value,
            [`${name}Err`]: null
        }));
    };

    // handleModalSubmit function
    const handleModalSubmit = async () => {
        const { name, deviceType } = modalData;

        // Validate input using existing utility function
        const validationError = validateInput(name, 'text');
        if (validationError) {
            setModalData(prev => ({
                ...prev,
                nameErr: validationError
            }));
            return;
        }

        // Check if API is available for this tab
        const apiUrl = API_CONFIG[activeTab];
        if (!apiUrl) return;

        // Create payload based on active tab
        const payload = { name };
        if (activeTab == "Device Models" && deviceType == "AIS140") payload["deviceType"] = "AIS140";

        // Use useApiRequest hook for API call
        await request({
            method: 'POST',
            url: apiUrl,
            body: payload,
            onSuccess: () => {
                // Call success callback to refresh data
                if (onSuccess) onSuccess();
                handleModalClose();
            },
        });
    };

    // Handle modal close
    const handleModalClose = () => {
        setModalData({ name: '', nameErr: null });
        onHide();
    };

    return (
        <ModalElement
            FooterComponent={<div className="text-center my-2">
                <ButtonElement
                    text="Submit"
                    cssClass="small-radius mb-1"
                    onClick={handleModalSubmit}
                    variant="btn-outline-primary"
                    loading={loading}
                />
            </div>}
            show={show}
            title={`Add ${activeTab.slice(0, -1)}`}
            onHide={handleModalClose}
            size="md"
        >
            <div className="text-start">
                <div className="mb-3">
                    <InputElement
                        label={`${activeTab.slice(0, -1)} Name`}
                        placeholder={`Enter ${activeTab.slice(0, -1).toLowerCase()} name`}
                        name="name"
                        value={modalData.name}
                        error={modalData.nameErr}
                        onChange={handleModalChange}
                    />
                </div>
                {
                    activeTab === 'Device Models' && (
                        <SearchableDropdown
                            isRequired={false}
                            label={"Device Type"}
                            placeholder={"Device Type"}
                            error={false}
                            value={modalData?.deviceType}
                            options={dropdownDefaultList.list}
                            onSelect={(value) => handleModalChange({ target: { name: "deviceType", value: value?.name ?? "" } })}
                        />
                    )
                }
            </div>
        </ModalElement>
    );
};

export default AddModal;
